angular.module('admin.home', []).controller('HomeCtrl',
    function ($state) {

    }).config(function ($stateProvider) {
        $stateProvider.state('admin.home', {
            templateUrl: 'views/home/view.html',
            controller: 'HomeCtrl',
            controllerAs: 'ctrl',
            url: 'home'
        });
    });